import UserStore from 'src/stores/alt/stores/UserStore';

export function getDashboardUserContext() {
  const { currentUser = null } = UserStore.getState();
  const userId = currentUser && typeof currentUser.id === 'number' ? currentUser.id : null;
  const displayName = currentUser?.name || currentUser?.initials || 'User';

  return {
    userId,
    displayName,
  };
}
